// extracted by mini-css-extract-plugin
export default {"root":"_Y3SjJ","innerContainer":"ymj7CI","icon":"oH0FR8","outerWrapper":"NhSuwd","text":"nWg7OY"};